// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';

// Importante: Cargar la inicialización de AG Grid antes de cualquier otro componente
import './config/ag-grid-initializer';

// Estilos en orden correcto (primero bootstrap, luego ag-grid, después estilos personalizados)
import 'bootstrap/dist/css/bootstrap.min.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import './styles/ag-grid-styles.css';
import './styles/rounded-corners.css'; // 
import './styles/datalist-styles.css'; // 
import './index.css';
import './theme.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();